import React from 'react';
import { Link, routeHistory } from '@nackle/biw-web-router';
import {
    FileUpload,
 } from '../../../loader-hatch/index';
 import auth from '../../app-auth';

export default class LoadPage extends React.Component {
    render() {
        const {
            route: {
                params: {
                    fileType = ''
                } = {}
            } = {}
        } = this.props;

        return (
            <div className="page load-page">
                <div className="page-header">
                    <Link back>
                        Back
                    </Link>

                    <h1>Load</h1>
                </div>

                <FileUpload
                    auth={ auth }
                    fileType={ fileType.toUpperCase() }
                    onFileUploaded={ this.handleFileLoaded }
                    onUpdateFile={ ( { records } ) => records }
                />
            </div>
        );
    }

    handleFileLoaded = ( fileId ) => {
        routeHistory.push( `/files/${ fileId }` );
    };
}
